"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAWYER_GETTING_STARTED = void 0;
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.LAWYER_GETTING_STARTED = (0, form_1.form)({
    name: "LAWYER_GETTING_STARTED",
    title: "Lawyer Getting Started",
    content: [question_groups_1.QuestionGroup["LAWYER_GETTING_STARTED_PERSONAL_INFO"]],
    id: 33,
});
